module.exports = __webpack_public_path__ + "static/media/arigto-phantasmagorical.3392412.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/ware-2018/arigto-phantasmagorical.mp3
// module id = ah18
// module chunks = 0